import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StockCheckHistoryAction } from './stock-check-history.actions';
import {
  StockCheckHistoryListContent,
  StockCheckHistorySearchCriteria,
  StockCheckHistoryViewResponse
} from '../../model/stock-check-history.model';

export interface StockCheckHistoryState extends EntityState<StockCheckHistoryListContent> {
  isLoading: boolean;
  selected: StockCheckHistoryListContent[];
  criteriaObject: StockCheckHistorySearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewResponse: StockCheckHistoryViewResponse;
}

export const adapter: EntityAdapter<StockCheckHistoryListContent> = createEntityAdapter<StockCheckHistoryListContent>(
  {
    selectId: (model: StockCheckHistoryListContent) => model.recallNo
  }
);

export const initialState: StockCheckHistoryState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewResponse: null
});

export const StockCheckHistoryReducer = createReducer<StockCheckHistoryState>(
  initialState,
  on(StockCheckHistoryAction.responseList, (state, action): StockCheckHistoryState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
